import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import { MetamaskStateProvider } from "use-metamask";
import { UserWalletProvider } from "./contexts/walletContext";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import { AlertProvider } from "./contexts/AlertContext";

type TabsItem = {
  content?: () => JSX.Element;
  hidden?: boolean;
  hideIfLogin?: boolean;
  hideIfLogout?: boolean;
  noPassword?: boolean;
  href?: string;
  relativeHref?: string;
  path?: string;
  label: string | JSX.Element;
  children?: TabsItem[];
  hideHeader?: boolean;
  hideFooter?: boolean;
};

const tabs: TabsItem[] = [
  {
    path: "/",
    label: "Home",
    content: () => <Home />,
  },
];

const tabsFlat: TabsItem[] = [];

const loopTabsTree = (tabs: TabsItem[]) => {
  tabs.forEach((tab) => {
    tabsFlat.push(tab);
    if (tab.children) {
      loopTabsTree(tab.children);
    }
  });
};

loopTabsTree(tabs);

const PageLoading = () => null;

let dom = (
  <Routes>
    {tabsFlat.map((tab, i) => {
      if (!tab.path || !tab.content) return undefined;
      return (
        <Route
          key={i}
          path={tab.path}
          element={
            <Suspense fallback={<PageLoading />}>
              <App content={tab.content()} />
            </Suspense>
          }
        />
      );
    })}
  </Routes>
);

dom = <AlertProvider>{dom}</AlertProvider>;
dom = <UserWalletProvider>{dom}</UserWalletProvider>;
dom = <MetamaskStateProvider>{dom}</MetamaskStateProvider>;
dom = <BrowserRouter basename={process.env.PUBLIC_URL}>{dom}</BrowserRouter>;
dom = <React.StrictMode>{dom}</React.StrictMode>;

ReactDOM.render(dom, document.getElementById("root"));

reportWebVitals();
